/**
 * useMediaConfig
 */
import { useMemo } from 'react';
import _merge from 'lodash/merge';

import { MEDIA_CONFIG_CONTEXT } from '../../utils/constants';
import { useConfig } from '../../contexts/config';

const useMediaConfig = (context) => {

    const { mediaConfig } = useConfig();
    const config = useMemo(() => {

        return context ? _merge({}, mediaConfig[MEDIA_CONFIG_CONTEXT.app], mediaConfig[context]) : mediaConfig[MEDIA_CONFIG_CONTEXT.app];

    }, [
        mediaConfig,
        context,
    ]);

    return config;

};

export default useMediaConfig;
